import { Backdrop, Box, Button, CircularProgress, Container, Dialog, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { DefaultProps, AppState } from "../../types/types";
import { LandingSubmitType } from "../../types/landingTypes";
import IconDigitalePost from '../../assets/images/icon_digitale_post.svg';
import IconDigitalePostRd from '../../assets/images/icon_digitale_post_rd.svg';
import Exclamationmark from './../../assets/images/exclamationmark.svg';
import React, { ChangeEvent, useState } from "react";
import { getTenant, log } from "../../util/util";
import LinkedappBackend from "../../services/LinkedappBackend";
import { LandingpageRequestResultLinkType, LandingpageRequestType, Tenant } from "../../types/apimodel";
import { useLandingContext } from "./LandingProvider";
import { useNavigate } from 'react-router-dom';

import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { PatternFormat } from "react-number-format";
import { saveSessionData } from "../../util/store";
interface LandingProps extends DefaultProps {
    appState: AppState,
    landingSubmitType: LandingSubmitType,
    showBereitsregistriert?: boolean,
}

const Landing: React.FC<LandingProps> = props => {

    const { vorname,
        setVorname,
        nachname,
        setNachname,
        plz,
        setPlz,
        vsnr,
        setVsnr,

        setArrayOfEmailAdresses } = useLandingContext();



    const handleVornameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setVorname(event.target.value);
    }


    const handleNachnameChange = (event: ChangeEvent<HTMLInputElement>) => {
        setNachname(event.target.value);
    }


    const handlePlzChange = (event: ChangeEvent<HTMLInputElement>) => {
        setPlz(event.target.value);
    }




    const [vsnrInfoAnzeigen, setVsnrInfoAnzeigen] = useState(false);
    const [technischerFehler, setTechnischerFehler] = useState(false);
    const [falscheEingabe, setFalscheEingabe] = useState(false);

    let params = new URLSearchParams(window.location.href);
    let lpfromlinktoken = params.get("lpfromlinktoken") || '';

      //const [loading, setLoading] = useState(false);
    const lpfromlinktokenVorhanden: boolean = !!lpfromlinktoken;
    const [loading, setLoading] = useState(lpfromlinktokenVorhanden);


  


    const isInputComplete = (): boolean => {
        let result: boolean = [vorname, nachname, plz, vsnr].every(str => str.trim() !== '');
        if (result) {
            if (vsnr.replace(/\D/g, '').length < 17) {
                result = false;
            }
        }
        if (!result) {
            setFalscheEingabe(true);
        }
        return result;
    }

    const navigate = useNavigate();

    const handleVsnrChange = (event: ChangeEvent<HTMLInputElement>) => {
        setVsnr(event.target.value);
    }



    const getlandingpageRequestType = ()=> {
        let landingpageRequestType: LandingpageRequestType;
        if (props.landingSubmitType === LandingSubmitType.SIGNUP) {
            //For die folge Seite muessen die E-Mail Adressen ermittelt werden
            landingpageRequestType = LandingpageRequestType.EMAILADRESSES;
        } else if (props.landingSubmitType === LandingSubmitType.SINGOFF) {
            landingpageRequestType = LandingpageRequestType.SIGNOFF;
        }
        return landingpageRequestType;
    }


    const weiterbutton = async () => {


        setLoading(true);

        setTechnischerFehler(false);
        setFalscheEingabe(false);


        function getEnumLandingpageRequestResultLinkTypeByName(name: string): LandingpageRequestResultLinkType | undefined {
            for (const key in LandingpageRequestResultLinkType) {
                if (LandingpageRequestResultLinkType.hasOwnProperty(key)) {
                    if (key === name) {
                        return LandingpageRequestResultLinkType[key as keyof typeof LandingpageRequestResultLinkType];
                    }
                }
            }
            setLoading(false)
            return undefined;
        }


        let landingpageRequestType = getlandingpageRequestType();
     


        let tenant: Tenant = getTenant(window.location.href);

        let logMsg = "Vorname: " + vorname + " , Nachname: " + nachname + " , Plz: " + plz + " , vsnr: " + vsnr + " , landingpageRequestType: " + landingpageRequestType + " , tenant: " + tenant;
        log(logMsg);
        if (isInputComplete()) {

            LinkedappBackend.getLandingpageLink(vorname, nachname, plz, vsnr, landingpageRequestType, tenant, null).then((data) => {
                log("Retrieved data: ", data);
                if (data.technicalError) {
                    setTechnischerFehler(true);
                } else if (!data.inputValid || !data.generatedLink) {
                    setFalscheEingabe(true);
                } else {
                    log("Link erhalten: " + data.generatedLink);
                    if (data?.landingpageRequestResultLinkType !== undefined && getEnumLandingpageRequestResultLinkTypeByName(data.landingpageRequestResultLinkType.toLocaleString()) === LandingpageRequestResultLinkType.MAILBOX) {
                        //Sicherheitshalber weitere Authentifizierung
                        window.location.replace(data.generatedLink);
                    } else if (data?.landingpageRequestResultLinkType !== undefined && getEnumLandingpageRequestResultLinkTypeByName(data.landingpageRequestResultLinkType.toLocaleString()) === LandingpageRequestResultLinkType.LIST_EMAILADRESSSES) {
                        //E-Mails Speichern und zweite Seite aufrufen

                        setArrayOfEmailAdresses(data.arrayOfEmailAdresses);
                        navigate(data.generatedLink, { replace: true });

                    } else {
                        //Nur fall /link/open/ ansonsten short link
                        window.location.replace(data.generatedLink + "&KNOWN_DATE_POSTCODE=" + plz);
                    }

                }
                setLoading(false);
            }).catch(error => {
                console.log('error in getLandingpageLink: ' + JSON.stringify(error));
                setTechnischerFehler(true);
                setLoading(false);
            });

        } else {
            setLoading(false);
        }
        //Falls Postfach bereits vorhanden -> direkt hinspringen
        //Falls Kein Postfach -> Zur Registierung springen

    }

    const styles = {
        imageSmall: {
            cursor: 'pointer', // Cursor zur Hand ändern
            width: "50%",
            marginLeft: '1rem'
        },
        imageLarge: {
            cursor: 'pointer', // Cursor zur Hand ändern
            width: { xs: '120px', sm: '150px', md: '250px', lg: '250px' },
            marginLeft: '1rem'
        }
    };

    const handleVsnrInfoAnzeigeChange = () => {
        setVsnrInfoAnzeigen(!vsnrInfoAnzeigen);
    }


    function VsnrInfoDialog(props: LandingProps) {




        return (
            <Box>
                {vsnrInfoAnzeigen &&
                    <Dialog open={true} className="dialogCenterInfo" sx={{ marginTop: "30%", height: { sx: "650px", xs: "650px", md: "450px", lg: "450px" } }}

                    >
                        <DialogTitle sx={{ display: 'flex', flexDirection: 'row', paddingBottom: "0px" }} >
                            <b>Versicherungsscheinnummer</b>

                            <Box
                                sx={{ display: 'flex', flexGrow: 1, paddingTop: "0em", paddingBottom: "0em" }}></Box>
                            <IconButton
                                aria-label="close"
                                onClick={handleVsnrInfoAnzeigeChange}
                                sx={{
                                    bgcolor: '#fff',
                                    right: -18,
                                    top: 0,
                                }}
                                size="large">
                                <CloseIcon
                                    sx={{ height: "34px", width: "34px", marginTop: "-10px", color: "#616161" }}
                                />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent sx={{ marginTop: "0px", overflow: "hidden" }} onClick={handleVsnrInfoAnzeigeChange}>
                            <hr />
                            <Box sx={{ marginTop: "20px" }}>
                                Wenn Sie mehrere Verträge bei den RheinLand Versicherungen haben, genügt die Angabe einer Versicherungsscheinnummer. Die An-/Abmeldung erfolgt für alle Verträge, die über Ihre Kundenverbindung hinterlegt sind.<br /><br />

                                Sie finden Ihre Versicherungsscheinnummer auf Ihrer Beitragsrechnung oder auf Ihrem Versicherungsschein. Sie besteht immer aus einer Zahlenkombination in diesem Aufbau:
                                <br />
                                <br />
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20px' }}>
                                    <h3>11/11-1111-11111111-1</h3>
                                </div>
                            </Box>
                        </DialogContent>
                    </Dialog>}
            </Box>
        );
    }

    const removeQueryParam = (url: string, paramToRemove: string): string => {
        // Parse die URL
        const urlObj = new URL(url);

        // Entferne den gewünschten Parameter
        urlObj.searchParams.delete(paramToRemove);

        // Gebe die neue URL als String zurück
        return urlObj.toString();
    };

    const jumpToEmailSelectionIfQueryParameterExists = () => {
        function getEnumLandingpageRequestResultLinkTypeByName(name: string): LandingpageRequestResultLinkType | undefined {
            for (const key in LandingpageRequestResultLinkType) {
                if (LandingpageRequestResultLinkType.hasOwnProperty(key)) {
                    if (key === name) {
                        return LandingpageRequestResultLinkType[key as keyof typeof LandingpageRequestResultLinkType];
                    }
                }
            }
            setLoading(false)
            return undefined;
        }

        let params = new URLSearchParams(window.location.href);
        saveSessionData("lpfromlinktoken", null);
        let lpfromlinktoken = params.get("lpfromlinktoken") || '';
        if (lpfromlinktoken) {
            let landingpageRequestType = getlandingpageRequestType();

            LinkedappBackend.getLandingpageLinkForEmail(lpfromlinktoken,landingpageRequestType, null).then((data) => {
                log("Retrieved data: ", data);
                if (data.technicalError) {
                    setTechnischerFehler(true);
                    //Fehlerfall
                    const updatedUrlWithoutToken = removeQueryParam(window.location.href, "lpfromlinktoken");
                    window.location.replace(updatedUrlWithoutToken);
                } else if (!data.inputValid || !data.generatedLink) {
                    //Remove Parameter and show only landingpage
                    setFalscheEingabe(true);
                    //Fehlerfall
                    const updatedUrlWithoutToken = removeQueryParam(window.location.href, "lpfromlinktoken");
                    window.location.replace(updatedUrlWithoutToken);
                } else {
                    log("Link erhalten: " + data.generatedLink);
                    saveSessionData("lpfromlinktoken", lpfromlinktoken);
                    removeQueryParam(window.location.href, "lpfromlinktoken");
                    if (data?.landingpageRequestResultLinkType !== undefined && getEnumLandingpageRequestResultLinkTypeByName(data.landingpageRequestResultLinkType.toLocaleString()) === LandingpageRequestResultLinkType.MAILBOX) {
                        //Sicherheitshalber weitere Authentifizierung
                        window.location.replace(data.generatedLink);
                    } else if (data?.landingpageRequestResultLinkType !== undefined && getEnumLandingpageRequestResultLinkTypeByName(data.landingpageRequestResultLinkType.toLocaleString()) === LandingpageRequestResultLinkType.LIST_EMAILADRESSSES) {
                        //E-Mails Speichern und zweite Seite aufrufen

                        setArrayOfEmailAdresses(data.arrayOfEmailAdresses);
                        navigate(data.generatedLink, { replace: true });

                    } else {
                        //Fehlerfall
                        const updatedUrlWithoutToken = removeQueryParam(window.location.href, "lpfromlinktoken");
                        window.location.replace(updatedUrlWithoutToken);
                    }

                }
                setLoading(false);
            }).catch(error => {
                console.log('error in getLandingpageLink: ' + JSON.stringify(error));
                setTechnischerFehler(true);
                setLoading(false);
            });

        } else {
            //nothing
        }
    }

    jumpToEmailSelectionIfQueryParameterExists();

    return (
        <Container maxWidth="lg" className="container" >

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid container alignItems="flex-start" spacing={3} sx={{ overflowX: 'auto', marginTop: { md: '2rem', lg: '2rem' } }}>

                {props.landingSubmitType === LandingSubmitType.SIGNUP &&
                    <Grid item xs={12}>
                        {!props.showBereitsregistriert &&<h1>Sie wollen Ihre Post in Zukunft digital erhalten?</h1>}
                        {props.showBereitsregistriert &&<h1>Sie sind schon registriert?</h1>}
                    </Grid>

                }
                <Grid item xs={12} sx={{ display: { xs: 'flex', sm: 'flex', md: 'none', lg: 'none' }, marginBottom: "20px", justifyContent: { xs: 'center', md: 'right', sm: 'center', lg: 'right' }, textAlign: 'right', alignItems: 'center' }}>
                    {props.appState.customizingId === 'rd' &&
                        <Box component="img" sx={styles.imageSmall} alt="Postfach" src={IconDigitalePostRd}></Box>}
                    {props.appState.customizingId === 'rl' &&
                        <Box component="img" sx={styles.imageSmall} alt="Postfach" src={IconDigitalePost}></Box>}
                </Grid>
            </Grid>
            <Grid container spacing={3} alignItems="flex-start">
                <Grid item xs={12} md={8} lg={8}>
                    <Grid container spacing={3} sx={{ overflowX: 'auto', marginTop: { md: '2rem', lg: '2rem' } }}>
                    {!props.showBereitsregistriert &&<Grid item xs={12}>
                            Wir benötigen Ihre Angaben, damit wir Sie eindeutig identifizieren können.

                            {/*<Tooltip placement="bottom" color="secondary" title={
                                <React.Fragment >
                                    Tooltip text
                                </React.Fragment>
                            } arrow>
                                <IconButton>
                                    <InfoIcon />
                                </IconButton>
                            </Tooltip>*/}

                        </Grid>}
                        {props.showBereitsregistriert &&<Grid item xs={12}>
                            Einfach kurz identifizieren, und wir bringen Sie sicher zu Ihrem Digitalen Postfach.
                        </Grid>}
                        <Grid item xs={12} md={6} lg={6} >
                            <TextField placeholder='Vorname' value={vorname} onChange={handleVornameChange}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={6} >
                            <TextField placeholder='Nachname' value={nachname} onChange={handleNachnameChange}
                                sx={{ width: '100%' }}
                            />
                        </Grid>


                        <Grid item xs={12} md={6} lg={6}>
                            <TextField placeholder='Postleitzahl' value={plz} onChange={handlePlzChange}
                                sx={{ width: '100%' }}
                            />
                        </Grid>

                        <Grid item xs={6} sx={{ display: { xs: "none" } }}>

                        </Grid>

                        <Grid item xs={12}>

                            <VsnrInfoDialog appState={props.appState} landingSubmitType={props.landingSubmitType} />
                            <PatternFormat
                                {...props}
                                format="##/##-####-########-#"
                                customInput={TextField}
                                mask="_"

                                value={vsnr}
                                sx={{ width: '100%' }}
                                placeholder='Versicherungsscheinnummer (z.B.: 69/69-1234-12345678-1)'
                                onChange={handleVsnrChange}
                                InputProps={{
                                    endAdornment: (


                                        <IconButton onClick={handleVsnrInfoAnzeigeChange}>
                                            <InfoIcon sx={{ color: props.appState?.customizing?.colors?.secondary }} />
                                        </IconButton>

                                    ),
                                }}
                            />
                        </Grid>



                        {falscheEingabe && <Grid item xs={12} md={12} lg={12} sm={12} >
                            <Grid container alignItems="flex-start" className={"errorMessageGrid"}>
                                <Grid item xs={2} md={1} lg={1} sm={1}>
                                    <Box component="img" sx={{ width: { xs: '15px', sm: '15px', md: '15px', lg: '15px' }, marginLeft: '1rem', marginRight: '0.5rem', paddingTop: '5px' }} alt="Postfach" src={Exclamationmark}></Box>
                                </Grid>
                                <Grid item xs={10} md={11} lg={11} sm={11}>
                                    <b>Wir konnten Sie leider nicht identifizieren.</b><br />
                                </Grid>
                                Bitte überprüfen Sie Ihre Eingaben auf Tippfehler.<br />
                                Sollten alle Eingaben richtig sein, setzen sie sich mit Ihrem Vermittler in Verbindung.
                            </Grid>
                        </Grid>}

                        {technischerFehler && <Grid item xs={12} md={12} lg={12} sm={12}>

                            <Grid container alignItems="flex-start" className={"errorMessageGrid"}>
                                <Grid item xs={2} md={1} lg={1} sm={1}>
                                    <Box component="img" sx={{ width: { xs: '15px', sm: '15px', md: '15px', lg: '15px' }, marginLeft: '1rem', marginRight: '0.5rem', paddingTop: '5px' }} alt="Postfach" src={Exclamationmark}></Box>
                                </Grid>
                                <Grid item xs={10} md={11} lg={11} sm={11}>
                                    <b>Technischer Fehler</b><br />
                                </Grid>
                                Versuchen Sie es später noch einmal
                            </Grid>
                        </Grid>}


                        <Grid item xs={12} md={9} lg={9} sx={{ display: { xs: "none", md: "flex", lg: "flex" } }}>

                        </Grid>
                        <Grid item xs={12} md={3} lg={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>

                            <Button title={'Weiter'} onClick={weiterbutton} disabled={loading} id="weiterZumLink">WEITER</Button>
                        </Grid>


                        {props.landingSubmitType === LandingSubmitType.SIGNUP && !props.showBereitsregistriert &&
                            <Grid item xs={12}>
                                <hr />
                                <br />
                                Sie sind schon registriert, dann leiten wir Sie nach der Identifikation in Ihr Digitales Postfach.
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid item xs={4} sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex' } }}>
                    {props.appState.customizingId === 'rd' &&
                        <Box component="img" sx={styles.imageLarge} alt="Postfach" src={IconDigitalePostRd}></Box>}
                    {props.appState.customizingId === 'rl' &&
                        <Box component="img" sx={styles.imageLarge} alt="Postfach" src={IconDigitalePost}></Box>}
                </Grid>
            </Grid>
        </Container>
    );
}

export default Landing;